import * as React from "react";
import type { TableProps } from "./types";

export function resolveRowKey<T>(
  rowKey: TableProps<T>["rowKey"],
): (row: T, index: number) => React.Key {
  if (typeof rowKey === "function") return (row, index) => rowKey(row, index);
  if (typeof rowKey === "string") return (row) => (row as any)?.[rowKey];
  return (row, index) => (row as any)?.id ?? index;
}

export function getTableStyle(scroll: TableProps<any>["scroll"]): React.CSSProperties | undefined {
  if (!scroll?.x) return undefined;
  return {
    minWidth:
      scroll.x === true
        ? "max-content"
        : typeof scroll.x === "number"
          ? `${scroll.x}px`
          : scroll.x,
  };
}

